

































































































helpers = require('../../helpers.coffee')

view_model =
  components:
    tag: require('../tags/tag')
    contactList: require('../contacts/list')

  data: ->
    business: new Business
    contacts: []
    contact_filter: {}
    contact_next_page: 1
    current_user: Session.current_user
    contacts_loading: false
    selected_contact: null

  computed:
    statusIconClass: ->
      switch @business.status
        when 'paused' then 'contact-event-subicon paused-icon'
        when 'active' then 'contact-event-subicon active-icon'
        when 'uninitialized' then 'contact-event-subicon uninitialized-icon'
        when 'scheduled_reactivation' then 'contact-event-subicon scheduled_reactivation-icon'
        else 'contact-event-subicon finished-icon'

    stageClasses: ->
      "btn-contact-stage btn-contact-fake contact-stage-#{@business.stage}"

  methods:
    # Contacts methods
    toggleTaskBar: (data) ->
      EventsBus.$emit 'toggle-task-bar', data.contact.id

    openDestroyContactConfirmationModal: (data) ->
      @selected_contact = data.contact
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contact'

    callDestroyContact: ->
      @destroyContact(contact: @selected_contact, @contact_resource)

    submit: ->
      @$validator.validateAll().then (success) =>
        @save() if success

    save: ->
      @businesses_resource.update @saveSuccess, @unknownError, @business

    saveSuccess: (data) ->
      alertify.success this.$t('businesses.feedback.saveSuccess')

    loadBusiness: ->
      Loader.on()
      params = {include_contact_custom_fields: true}
      @businesses_resource.get @loadSuccess, @loadFailure, id: @$route.params.id, params: params

    loadFailure:(data) ->
      if data.status == 403
        @$router.push '/contatos/empresas'
      else
        alertify.error this.$t('businesses.feedback.unknownFail')

    loadSuccess: (resources) ->
      Loader.off()
      @business = resources.business
      @contact_filter = { business_id_eq: @business.id }
      @loadContacts()

    loadContacts: ->
      return if @contacts_loading || !@contact_next_page || !@business.id
      @contacts_loading = true
      params = {}
      params.q = @contact_filter
      params.page = @contact_next_page
      @contact_resource.index(@loadContactsSuccess, @unknownError, {params})

    loadContactsSuccess: (resources) ->
      @contacts_loading = false
      @contact_next_page = resources.meta.next_page
      @contacts = @contacts.concat(resources.contacts)

    unknownError: ->
      Loader.off()
      alertify.error this.$t('businesses.feedback.errorTitle')

  created: ->
    @businesses_resource = new BusinessesResource()
    @contact_resource = new ContactsResource(Session.current_company.id)

    @loadBusiness()

exports.default = helpers.vue_include(view_model, helpers.form,
                                                  helpers.contacts.list_view_modes,
                                                  helpers.contacts.list_wrapper,
                                                  helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/businesses/show.vue